// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__2y3bq","errorLogs":"EditorFooter_errorLogs__32hb4"};